import React, {
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectorExamQuestions } from 'src/app/slices/examSlice'
import {
  Button,
} from '@material-ui/core'
import {
  makeStyles,

} from '@material-ui/core/styles'
import { useParams } from 'react-router-dom'
import styles from './Survey.module.css'
import {
  getUserExamQuestions,
  answerQuestion,
  finishQuiz,
} from '../../app/slices/examSlice'

import SurveyIcon from '../../icons/SurveyIcon'
import { selectorUsersPackage, getUsersPackages } from '../../app/slices/packageSlice'

const useStyles = makeStyles({
  root: {
  },
  surveyBtn: {
    backgroundColor: '#f39994',
    width: '10%',
    height: '37px',
    borderRadius: '20px',
    color: '#ffffff',
    textAlign: 'center',

    fontWeight: '600',
    display: 'flex',

    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
    '@media (max-width: 960px)': {
      width: '25% !important',
    },
    '@media (max-width: 600px)': {
      width: '35% !important',
    },

  },
  survey_footer_wrap: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
  },
  question_wrap: {
    display: 'flex',
    margin: '40px 0 20px',
    flexFlow: 'column',
  },
  question: {
    width: 'auto',
    // width: '50%',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'baseline',
  },
  question_title: {
    fontWeight: 600,
    fontSize: '1rem',
    color: '#3a455d',
    margin: '10px 0',
  },
  question_input: {
    margin: '8px 7px 8px 0',
    fontSize: '40px',
    width: '1rem',
    height: '1rem',
    backgroundColor: 'red',
    '&:checked': {
      border: '6px solid red',
    },
  },
  category_title: {
    fontWeight: 600,
    fontSize: '1.2rem',
    color: '#3a455d',
    margin: '20px 0',
  },
  category_description: {
    fontWeight: 400,
    fontSize: '1.1rem',
    color: '#3a455d',
    margin: '20px 0',
  },
})

const Survey = () => {
  const questions = useSelector(selectorExamQuestions)
  const dispatch = useDispatch()
  const classes = useStyles()
  const userExams = useSelector(selectorUsersPackage)
  const { userExamId } = useParams()

  const [answer, setAnswer] = useState(false)

  console.log(answer)

  const getUserExam = userExams?.find((item) => item?.id === +userExamId)

  useEffect(() => {
    dispatch(getUserExamQuestions({ first: 100, after: 0, UserExamId: userExamId }))
    dispatch(getUsersPackages())
  }, [])

  console.log(questions)
  console.log(userExamId)
  console.log(getUserExam)
  console.log(userExams)

  const handleChange = (question, option) => (e) => {
    console.log('checked', e.target.checked)

    setAnswer(e.target.checked)

    if (e.target.checked) {
      const data = {
        userExam: {
          id: userExamId,
        },
        question: {
          id: question?.id,
        },
        examOption: {
          id: option?.id,
        },
      }

      dispatch(answerQuestion(data))
    } else {
      e.target.parentElement.previousElementSibling.children[0].checked = false
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(finishQuiz(userExamId))
  }

  return (
    <div className={styles.survey_wrap}>
      <div className={styles.survey_header_wrap}>
        <SurveyIcon />
        <div className={styles.survey_header_title_wrap}>
          <span className={styles.survey_header_title}>کاربر عزیز و گرامی سلام</span>
          <span className={styles.survey_header_title}>
            از اینکه برای پرنمودن این پرسشنامه وقت میگذارید از شما متشکریم
          </span>
        </div>
      </div>
      <form onSubmit={handleSubmit}>

        <div className={classes.question_wrap}>
          {questions?.map((question, index) => {
            const newCategory = question?.category
            && (question?.category?.id !== questions?.[index - 1]?.category?.id)
            // const QuestionsCategory =
            return (
              <div>
                <div
                  style={{ margin: '20px 0' }}

                >
                  <span
                    className={classes.category_title}
                  >
                    {newCategory && question?.category?.title}
                    {newCategory && ': '}
                  </span>

                  <span className={classes.category_description}>
                    {newCategory && question?.category?.description}
                  </span>
                </div>
                <div key={question?.id} className={classes.question}>
                  <p className={classes.question_title}>
                    {question?.order}
                    -
                    {' '}
                    {question?.question}
                  </p>
                  <div>
                    {question?.options?.map((option) => {
                      return (
                        <div key={option?.id}>
                          <div className={styles.container_input}>
                            <span className={styles.question_text_desc}>
                              {option?.title}
                            </span>
                            <input
                              type="radio"
                              name={option?.questionId}
                              className={styles.question_input}
                              onChange={handleChange(question, option)}
                            />
                            <span className={styles.checkmark} />
                          </div>

                        </div>
                      )
                    })}
                  </div>

                </div>
              </div>
            )
          })}
        </div>

        <div className={classes.survey_footer_wrap}>
          <Button type="submit" className={classes.surveyBtn}>
            ارسال
          </Button>
        </div>
      </form>
    </div>
  )
}

export default Survey
